/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';

export const googleAddressSearchAPI = async function ({
    address,
}) {
    const base = 'https://maps.googleapis.com/maps/api/geocode/json';

    const url = new URL(base);

    const params = {
        address,
        key: config.googleMapsApiKey,
    };

    url.search = new URLSearchParams(params).toString();

    const response = await fetch(url);
    const json = await response.json();
    return json;

    // return fetch({
    //     url,
    //     params: {
    //         address,
    //         key: config.googleMapsApiKey,
    //     },
    // });
};

export default {
    googleAddressSearchAPI,
};
